// extracted by mini-css-extract-plugin
module.exports = {"posts":"Posts_posts__3alYI","postdiv":"Posts_postdiv__Z-3Ju"};